import React, { useState } from 'react'

import { toast } from 'react-toastify'

import MessageBody from './MessageBody'
import Reply from './Reply'
import { AttachmentList } from '@/components/AttachmentList'
import { useDeleteMessageMutation } from '@/services/message'
import { ApplicationProfile, IMessage } from '@/types/unlock'
import { toastDefaultOptions } from '@/utils/toast'

export default function Message(
  props: IMessage & {
    applicants?: ApplicationProfile[]
    nonApplicants?: ApplicationProfile[]
  }
) {
  const { child_messages: ChildMessages, attachments } = props
  const [isReplies, setIsReplies] = useState<boolean>(false)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [deleteMessage] = useDeleteMessageMutation()

  const flattenChildren = (arr, nestingKey, childList = []) =>
    arr.reduce((childs, child) => {
      childList.push(child)
      if (child[nestingKey].length === 0) return childList

      return flattenChildren(child[nestingKey], nestingKey, childList)
    }, [])

  const replies = flattenChildren(ChildMessages, 'child_messages').sort(
    (left, right) => new Date(left.created_at).getTime() - new Date(right.created_at).getTime()
  )
  const repliesCount = replies.length

  const handleDeleteMessage = async () => {
    if (confirm('Are you sure you want to delete this message?')) {
      try {
        setDeleteLoading(true)
        const response: any = await deleteMessage(props.uuid)
        if (response.error) {
          throw new Error(response.error)
        }
        toast.success('Message deleted successfully.', { ...toastDefaultOptions })
      } catch (error) {
        console.error(error)
        toast.error('There was an error deleting the message. Please try again.', {
          ...toastDefaultOptions,
        })
      } finally {
        setDeleteLoading(false)
      }
    }
  }

  return (
    <>
      <div
        className={`w-full card bg-base-100 shadow-md flex flex-col border rounded-2xl ${repliesCount > 0 && isReplies ? '!rounded-2xl !rounded-br-none' : ''}`}
      >
        <MessageBody
          {...props}
          setIsReplies={setIsReplies}
          handleDeleteMessage={handleDeleteMessage}
          deleteLoading={deleteLoading}
          isReplies={isReplies}
          hasReplies={repliesCount > 0}
          applicants={props.applicants}
          nonApplicants={props.nonApplicants}
        />
        <AttachmentList attachments={attachments} />
      </div>
      {repliesCount > 0 && isReplies && (
        <div className='relative ml-6 pt-2'>
          <ul className='mb-3 flex flex-col gap-2'>
            {repliesCount > 0 &&
              replies &&
              isReplies &&
              replies.map((reply, rKey) => {
                return (
                  <Reply
                    key={rKey}
                    isLastIndex={rKey === replies.length - 1}
                    {...reply}
                  />
                )
              })}
          </ul>
        </div>
      )}
    </>
  )
}
